// extracted by mini-css-extract-plugin
export default {"container":"NVPartiesList_container__wwx6-","cardWrapper":"NVPartiesList_cardWrapper__obcaR"};